import { render } from "./LocalsRequests.vue?vue&type=template&id=f1e78326&ts=true"
import script from "./LocalsRequests.vue?vue&type=script&lang=ts"
export * from "./LocalsRequests.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__